import * as sagaEffects from 'redux-saga/effects';

import { actionTypes as uploaderActionTypes, utils as uploaderUtils } from 'modules/uploader';

import { addImageMapRequest } from '../actions';
import { imageMapsUploader } from '../config';

const { takeEvery, put } = sagaEffects;

function* handler({ meta, payload }) {
    if (meta.filesPool === imageMapsUploader) {
        yield put(addImageMapRequest(uploaderUtils.fileToImage(payload)));
    }
}

export default function* () {
    yield takeEvery(uploaderActionTypes.SET_FILE, handler);
}
